export default __webpack_public_path__ + "static/americana-2681e57a89c51fdd8bfec38007e42b2d.woff";